import axios from "axios";
import Api from "../../config/api/axios.urlcontext"

export default class informeFinanzaPub {

    async getMenuInformeFinanzaPub(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }
    // Evolución del gasto
    async getEvolucionGastosHistorico(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }
    async getEvolucionGastosClasiyDesag(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }
    //Elementos Programáticos
    async getElementoProgramaticos(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }
    async getElemProgPorAnioyOpc(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }
    //Informes Contables
    async getOpcionesInformesContables(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url)
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }
    async getInfoPorEstado(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }

    ///Información Financiera de los Entes Públicos
    async getOpcionesIFEP(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }
    async getInfoIFEPPorOpc(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }

    async getProcesoDeudaPublica(url){
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res.data;
        } catch (error) {
            console.error(error.message);
        }
    }
}